<template>
  <div>
    <b-tabs content-class="mt-3" v-model="tab_index">
      <b-tab
        v-if="
          (institution &&
            !['udalba.cl', 'enac.cl'].includes(institution.internal_use_id)) ||
          (unit_competence && unit_competence.full_sentence.length > 1)
        "
      >
        <template #title>
          {{
            $getVisibleNames(
              "teaching.tempcompetenceunit",
              false,
              "Unidad de competencia"
            )
          }}
        </template>
        <SentenceForm
          :first_content="unit_competence.action"
          :second_content="unit_competence.content"
          :third_content="unit_competence.condition"
          :full_sentence="unit_competence.full_sentence"
          :verb="unit_competence.verb"
          third_content_comment
          :is_required="
            institution &&
            !['udalba.cl', 'enac.cl'].includes(institution.internal_use_id)
          "
          @update="slotUpdateSentence"
          @mode="base_sentence_toggle = $event"
        ></SentenceForm>
      </b-tab>
      <b-tab :title="$t('matrix2.matrix2View.details')">
        <b-form-group
          label-cols="0"
          label-cols-lg="3"
          label-size="sm"
          :label="$t('reusable.common.name') + ':'"
          label-for="input-name"
          :description="
            $t('matrix2.matrix2View.canAddName', {
              entity: $getVisibleNames(
                'teaching.tempcompetenceunit',
                false,
                'Unidad de competencia'
              ),
            })
          "
          class="m-0 p-0"
        >
          <b-form-input
            type="text"
            id="input-name"
            v-model="$v.unit_competence.name.$model"
            :state="validateState('name')"
            aria-describedby="input-name-feedback"
            size="sm"
          ></b-form-input>
          <b-form-invalid-feedback id="input-name-feedback">
            {{ $t("reusable.common.required") }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group
          v-if="matter && !matter.automatic_achievement_weighing"
          label-cols="0"
          label-cols-lg="3"
          label-size="sm"
          :label="$t('matrix2.matrix2View.weighing') + ':'"
          label-for="input-weighing"
          :description="
            $t('matrix2.matrix2View.specifyPercentage', {
              entity: $getVisibleNames(
                'mesh.egressprofilematter',
                false,
                'Asignatura'
              ),
            })
          "
          class="m-0 p-0"
        >
          <b-form-input
            type="number"
            id="input-weighing"
            min="0"
            max="100"
            v-model="$v.unit_competence.weighing.$model"
            :state="validateState('weighing')"
            aria-describedby="input-weighing-feedback"
            size="sm"
          ></b-form-input>
          <div
            v-if="
              WeighingAvailable > 0 &&
              unit_competence.weighing != '' &&
              unit_competence.weighing < WeighingAvailable
            "
            class="mb-2 alert-student-weighing"
          >
            {{ $t("matrix2.matrix2View.availableWeighingIs") }}:
            <strong>{{ WeighingAvailable - unit_competence.weighing }}%</strong>
          </div>
          <b-form-invalid-feedback id="input-weighing-feedback"
            >{{
              $t("matrix2.matrix2View.requiredFieldMaxPercent", {
                percent: WeighingAvailable,
              })
            }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group
          label-cols="0"
          label-cols-lg="3"
          label-size="sm"
          :label="$t('reusable.common.order') + ':'"
          label-for="input-order"
          :description="$t('matrix2.matrix2View.canSpecifyPosition')"
          class="m-0 p-0"
        >
          <b-form-input
            type="number"
            id="input-order"
            v-model="$v.unit_competence.order.$model"
            :state="validateState('order')"
            aria-describedby="input-order-feedback"
            size="sm"
          ></b-form-input>
          <b-form-invalid-feedback id="input-order-feedback">{{
            $t("reusable.common.required")
          }}</b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label-cols="0" label-cols-sm="5" class="label m-0">
          <template #label>
            <div class="weighing-label">
              <div class="label-content ml-1">
                {{ $t("matrix2.matrix2View.equivalentWeighing") }}:
                <span>
                  <InfoTooltip
                    class="info-icon"
                    :tooltip_text="
                      $t('matrix2.matrix2View.useEquivalentWeighing', {
                        entity: $getVisibleNames(
                          'teaching.ramicro',
                          false,
                          'RA Micro'
                        ),
                      })
                    "
                  >
                  </InfoTooltip
                ></span>
              </div>
            </div>
          </template>
          <div>
            <div class="d-flex">
              <div class="toggle-types noprint">
                <span
                  :class="{
                    'font-weight-bold':
                      unit_competence.automatic_achievement_weighing,
                  }"
                  >{{ $t("reusable.common.yes") }}</span
                >
                <b-button
                  class="check-type"
                  @click="
                    () => {
                      unit_competence.automatic_achievement_weighing =
                        !unit_competence.automatic_achievement_weighing;
                    }
                  "
                  variant="primary"
                >
                  <b-icon
                    icon="circle-fill"
                    class="icon-check"
                    :class="{
                      'icon-check-active':
                        !unit_competence.automatic_achievement_weighing,
                    }"
                    scale="0.7"
                  ></b-icon>
                </b-button>
                <span
                  :class="{
                    'font-weight-bold':
                      !unit_competence.automatic_achievement_weighing,
                  }"
                  >{{ $t("reusable.common.no") }}</span
                >
              </div>
            </div>
          </div></b-form-group
        >
      </b-tab>
      <b-form-group
        v-if="!isNaN(unit_competence.id)"
        label-for="input-modification-date"
        label-cols="0"
        label-cols-sm="0"
        class="p-0 m-0 mt-2"
      >
        <ModificationDate :Information="unit_competence"></ModificationDate>
      </b-form-group>
      <div
        class="row mt-2"
        :class="{ 'justify-content-end': isNaN(unit_competence.id) }"
      >
        <div class="col" style="text-align: left">
          <b-button
            v-if="show_delete_button && !isNaN(unit_competence.id)"
            class="mr-1"
            size="sm"
            variant="danger"
            @click="removeCompetenceUnit"
            >{{ $t("reusable.common.delete") }}</b-button
          >
        </div>
        <div class="d-flex text-aling-right">
          <b-button
            v-if="show_save_button"
            class="mr-3 ml-3"
            size="sm"
            @click="saveCompetenceUnit"
            >{{ $t("reusable.common.save") }}</b-button
          >
        </div>
      </div>
    </b-tabs>
  </div>
</template>

<script>
import { generateUniqueId, toast, showLoadingAlert } from "@/utils/utils";
import { validationMixin } from "vuelidate";

import {
  required,
  minValue,
  // maxValue,
  //   numeric,
} from "vuelidate/lib/validators";
import * as names from "@/store/names";
import { mapGetters } from "vuex";
export default {
  name: "CompetenceUnitForm",
  mixins: [validationMixin],
  components: {
    SentenceForm: () => import("@/components/reusable/SentenceForm"),
    InfoTooltip: () => import("@/components/reusable/InfoTooltip"),
    ModificationDate: () => import("@/components/reusable/ModificationDate"),
  },
  props: {
    matter_id: {
      type: Number,
      required: true,
    },
    CompetenceUnit: {
      type: Object,
      default: function () {
        return {
          id: generateUniqueId(),
          verb: null,
          action: "",
          content: "",
          condition: "",
          full_sentence: "",
          context: "",
          name: "",
          description: "",
          order: 1,
          weighing: 0,
          matter: this.matter_id,
          automatic_achievement_weighing: true,
          competence: null,
        };
      },
    },
    show_delete_button: {
      type: Boolean,
      default: false,
    },
    show_save_button: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      unit_competence: { ...this.CompetenceUnit },
      tab_index: 0,
      base_sentence_toggle: this.CompetenceUnit
        ? this.CompetenceUnit.content
          ? true
          : false
        : false,
    };
  },
  validations() {
    return {
      unit_competence: {
        name: {},
        description: {},
        // action: { required },
        // content: { required },
        // condition: { required },
        weighing: {
          required,
          minVlaue: minValue(0),
          isValid(value) {
            if (
              parseFloat(value) == 0 ||
              parseFloat(value) <= this.WeighingAvailable ||
              (this.matter && this.matter.automatic_achievement_weighing)
            )
              return true;
            else return false;
          },
          // maxVlaue: maxValue(this.WeighingAvailable),
        },
        order: { required, minVlaue: minValue(1) },
      },
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      institution: "getInstitution",
      competence_units: names.COMPETENCE_UNITS,
      matters: names.MATTERS,
      study_units: names.STUDY_UNITS,
    }),
    matter() {
      if (!this.matter_id) return null;
      return this.matters.find((x) => x.id == this.matter_id);
    },
    competenceUnits() {
      return this.competence_units.filter((x) => x.matter == this.matter_id);
    },
    WeighingAvailable() {
      let weighing = 100;
      this.competenceUnits.forEach((element) => {
        if (element.id != this.unit_competence.id) {
          weighing -= element.weighing;
        }
      });
      return weighing;
    },
  },
  methods: {
    validateState(key) {
      const { $dirty, $error } = this.$v.unit_competence[key];
      return $dirty ? !$error : null;
    },
    slotUpdateSentence(item) {
      this.unit_competence.verb = item.verb;
      this.unit_competence.action = item.first_content;
      this.unit_competence.content = item.second_content;
      this.unit_competence.condition = item.third_content;
      this.unit_competence.full_sentence = item.full_sentence;
      this.base_sentence_toggle = item.base_sentence_toggle;
    },
    removeCompetenceUnit() {
      const relatedStudyUnits = this.study_units.filter(
        (x) => x.temp_competence_unit == this.unit_competence.id
      );
      const studyUnitLabel = this.$getVisibleNames(
        "teaching.ramicro",
        true,
        "Unidades de estudio"
      );
      let htmlContent = `<p>${this.$t(
        "reusable.common.deleteConfirmText"
      )}</p>`;
      if (relatedStudyUnits.length > 0) {
        const names = relatedStudyUnits
          .map((u) => `<li>${u.name || u.full_sentence || u.id}</li>`)
          .join("");
        htmlContent += `<p><strong>${studyUnitLabel} ${this.$t(
          "reusable.common.toBeDeleted",
          "que se eliminarán"
        )}:</strong></p><ul style="text-align:left">${names}</ul>`;
      }
      this.$swal({
        title: this.$t("reusable.common.deleteConfirmTitle", {
          entity: this.$getVisibleNames(
            "teaching.tempcompetenceunit",
            false,
            "Unidad de competencia"
          ),
        }),
        html: htmlContent,
        type: "warning",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch(names.DELETE_STUDY_COMPETENCE, this.unit_competence.id)
            .then(() => {
              if (this.matter_id)
                this.$restful
                  .Get(
                    `teaching/toggle_matter_automatic_achievement_weighing/?matter=${this.matter_id}`
                  )
                  .then(() => {
                    this.$store
                      .dispatch(names.FETCH_COMPETENCE_UNITS, {
                        matter__id: this.matter_id,
                        force: true,
                      })
                      .then(() => {
                        this.$emit("deleted", this.unit_competence);
                      });
                  });
            });
        }
      });
    },
    // El cierre lo conecta cada pantalla que abre el formulario y no todas lo hacen, así
    // que se cierra el modal que lo contiene, sea cual sea
    closeParentModal() {
      const modal = this.$el.closest(".modal");
      if (modal && modal.id) this.$bvModal.hide(modal.id);
    },
    // Sin esto, Guardar no hace nada y no dice qué falta
    warnIncompleteSentence(action, content, condition) {
      const missing = [];
      if (action == "")
        missing.push(this.$t("reusable.sentenceContainer.mustSelectVerb"));
      if (content == "")
        missing.push(
          this.$t("reusable.sentenceContainer.contentCannotBeEmpty")
        );
      if (condition == "")
        missing.push(
          this.$t("reusable.sentenceContainer.conditionCannotBeEmpty")
        );
      toast(missing.join(" "));
    },
    saveCompetenceUnit() {
      if (
        this.institution &&
        ["udalba.cl", "enac.cl"].includes(this.institution.internal_use_id)
      ) {
        this.$v.unit_competence.$touch();
        if (this.$v.unit_competence.$anyError) return;
        if (isNaN(this.unit_competence.id)) this.createCompetenceUnit();
        else this.updateCompetenceUnit();
      } else if (this.base_sentence_toggle) {
        const action = (this.unit_competence.action || "").trim();
        const content = (this.unit_competence.content || "").trim();
        const condition = (this.unit_competence.condition || "").trim();

        if (action == "" || content == "" || condition == "") {
          this.tab_index = 0;
          this.warnIncompleteSentence(action, content, condition);
          return;
        }
        this.unit_competence.full_sentence = String(
          action + " " + content + " " + condition
        );
        this.$v.unit_competence.$touch();
        if (this.$v.unit_competence.$anyError) {
          this.tab_index = 1;
          return;
        }
        if (isNaN(this.unit_competence.id)) this.createCompetenceUnit();
        else this.updateCompetenceUnit();
      } else {
        const fullSentence = (this.unit_competence.full_sentence || "").trim();

        if (fullSentence != "") {
          this.$v.unit_competence.$touch();
          if (this.$v.unit_competence.$anyError) {
            this.tab_index = 1;
            return;
          }
          if (isNaN(this.unit_competence.id)) this.createCompetenceUnit();
          else this.updateCompetenceUnit();
        } else {
          this.tab_index = 0;
          toast(this.$t("reusable.sentenceContainer.contentCannotBeEmpty"));
        }
      }
    },
    createCompetenceUnit() {
      showLoadingAlert(
        this.$t("reusable.common.creatingInfo"),
        this.$t("reusable.common.creatingInfoText")
      );
      this.$store
        .dispatch(names.POST_STUDY_COMPETENCE, this.unit_competence)
        .then((response) => {
          this.$swal.close();
          toast(
            this.$getVisibleNames(
              "teaching.tempcompetenceunit",
              false,
              "Unidad de competencia"
            ) +
              " " +
              this.$t("matrix2.matrix2View.created")
          );
          if (this.matter_id)
            this.$restful
              .Get(
                `teaching/toggle_matter_automatic_achievement_weighing/?matter=${this.matter_id}`
              )
              .then(() => {
                this.$store.dispatch(names.FETCH_COMPETENCE_UNITS, {
                  matter__id: this.matter_id,
                  force: true,
                });
              });
          this.$emit("created", response);
          this.closeParentModal();
        });
    },
    updateCompetenceUnit() {
      showLoadingAlert(
        this.$t("reusable.common.updatingInfo"),
        this.$t("reusable.common.updatingInfoText")
      );
      this.$store
        .dispatch(names.UPDATE_STUDY_COMPETENCE, this.unit_competence)
        .then((response) => {
          this.$swal.close();
          toast(
            this.$getVisibleNames(
              "teaching.tempcompetenceunit",
              false,
              "Unidad de competencia"
            ) +
              " " +
              this.$t("matrix2.matrix2View.updated")
          );
          if (
            this.institution &&
            this.institution.show_competence_unit &&
            this.unit_competence.automatic_achievement_weighing
          )
            this.$restful
              .Get(
                `teaching/toggle_temp_competence_unit_automatic_achievement_weighing/?temp_competence_unit=${this.unit_competence.id}`
              )
              .then(() => {
                this.$store.dispatch(names.FETCH_STUDY_UNITS, this.matter_id);
              });
          this.$emit("updated", response);
          this.closeParentModal();
        });
    },
  },
  created() {
    if (isNaN(this.unit_competence.id)) {
      let order = 0;
      this.competenceUnits.forEach((x) => {
        if (order < x.order) order = x.order;
      });
      this.unit_competence.order = order + 1;
    }
  },
};
</script>

<style scoped>
.toggle-types {
  display: flex;
  float: right;
  padding: 0.3em 1.8em;
  border-radius: 3px;
}
.check-type {
  background: #007bff !important;
  margin-inline: 0.7em;
  height: 1.12em;
  width: 2.2em !important;
  margin-top: 2%;
  border-radius: 10px;
}
.check-type-disabled {
  background-image: linear-gradient(
    rgba(0, 0, 0, 0.5),
    rgba(0, 0, 0, 0.5)
  ) !important;
  margin-inline: 0.7em;
  height: 1.12em;
  width: 2.2em !important;
  margin-top: 2%;
  border-radius: 10px;
}
.icon-check {
  color: white;
  transform: translate(-69%, -50%);
  transition: 0.2s;
}
.icon-check-active {
  transform: translate(15%, -50%) !important;
}
.label-content {
  width: max-content;
}
.info-icon {
  position: relative;
  vertical-align: top;
  height: 12px;
  width: 12px;
}
.total-modules-label > .label-content {
  max-width: 7rem;
}
@media (max-width: 991px) {
  .info-icon {
    margin-left: 0;
  }
}
</style>

